import { useParams, useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import httpService from "../../services/HttpService";
import Header from "../common/Header";
import './RefundPage.css';
import { formattedPrice } from "../../utils/priceFormatter";
import OrderSingle from "./OrderSingle";

const RefundPage = () => {
    const { orderId } = useParams();
    const location = useLocation();
    const [order, setOrder] = useState(null);
    const [selectedReason, setSelectedReason] = useState("");
    const [customReason, setCustomReason] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [notification, setNotification] = useState(null);

    const reasons = [
        "Size does not fit",
        "Does not match description/photo",
        "Bad quality",
        "Defective",
        "Other"
    ];

    const queryParams = new URLSearchParams(location.search);
    const productId = queryParams.get('product_id');

    useEffect(() => {
        httpService.get(`/orders/${orderId}`)
            .then((res) => res.json())
            .then((data) => setOrder(data));
    }, [orderId]);


    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await httpService.get(`/products/${productId}`).then(response => response.json());
                setSelectedProduct(response);
            } catch (error) {
                console.error('Error fetching product:', error);
            }
        };

        productId && fetchProduct();
    }, [productId]);

    const handleRefundSubmit = async () => {
        const refundData = { 
            order_id: +orderId,
            reason: selectedReason === "Other" ? customReason : selectedReason,
            product_id: 49 //TODO: remove backend validation when selectedProduct is false
        };

        if (selectedProduct) {
            refundData.product_id = selectedProduct.id;
        }

        try {
            const response = await httpService.post('/refunds', refundData);
            const data = await response.json();
            setNotification('Возврат завершен');
        } catch (error) {
            console.error('Error refunding:', error);
        }

        setTimeout(() => setNotification(null), 1500);
    };


    if (!order) return <p>Loading refund details...</p>;

    return (
        <div>
            <Header />
            <main className="refund-main">
                <div className="refund-page">
                    <div className="title">Возврат</div>
                    <div className="delivered"><span>Доставлено</span> {order.date}</div>
                        {!productId && order && (
                            <OrderSingle hideHeader={true} />
                        )}
                        {selectedProduct && (
                            <div key={selectedProduct.id} className="cart-item">
                                <div className="cart-item-left">
                                    <Link className="link" to={`/product/${selectedProduct.id}`}>
                                        <img
                                            src={selectedProduct.main_image.link}
                                            alt={selectedProduct.name}
                                            className="cart-item-image"
                                        />
                                    </Link>
                                </div>
                                <div className="cart-item-middle">
                                    <p className="cart-item-name">{selectedProduct.name}</p>
                                    <p className="cart-item-brand-name">{selectedProduct.brand.name}</p>
                                    <p className="cart-item-size">Size: {selectedProduct.size}</p>
                                    <p className="order-size">{formattedPrice(selectedProduct.price, null, selectedProduct.sale)} {selectedProduct.actual_price} &#8381;</p>
                                </div>
                            </div>
                        )}

                     <div style={{ marginBottom: selectedReason === "Other" ? "60px" : "35px" }} className="refund-reasons-container">
                        <div className="reasons-dropdown" onClick={() => {setIsOpen(!isOpen); window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });}}>
                            <button className="dropdown-toggle">
                                {selectedReason || "Select a reason"} 
                                <span className="material-symbols-sharp">expand_more</span>
                            </button>
                            {isOpen && (
                                <ul className="dropdown-menu">
                                    {reasons.map((reason) => (
                                        <li key={reason}
                                            className={`dropdown-item ${reason === selectedReason ? "selected" : ""}`}
                                            onClick={() => {
                                                setSelectedReason(reason);
                                                setIsOpen(false);
                                            }}>
                                            {reason}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        {selectedReason === "Other" && (
                            <input
                                type="text"
                                className="custom-reason-input"
                                placeholder="Enter your reason"
                                value={customReason}
                                onChange={(e) => setCustomReason(e.target.value)}
                            />
                        )}
                    </div>
                    <div className="cart-total">
                        <div className="cart-button-wrapper">
                            <button className="cart-button" onClick={handleRefundSubmit}>
                                Сделать возврат
                            </button>
                        </div>
                    </div>
                </div>
                {notification && (
                    <div className="notification">
                        {notification}
                    </div>
                )}
            </main>
        </div>
    );
};

export default RefundPage;
